export default "__VITE_ASSET__DdGZKToo__"